export enum Languages {
  En = 'en',
  De = 'de',
}
